import script from "./DrivingRangePinsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DrivingRangePinsView.vue?vue&type=script&setup=true&lang=js"

import "./DrivingRangePinsView.vue?vue&type=style&index=0&id=601513a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-601513a0"]])

export default __exports__